import React, { useEffect, useRef, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import TabPanel from "@mui/lab/TabPanel";
import { TabContext } from "@mui/lab";
import "./Section.css";
import SuccessAlert from "../components/success-alert/SuccessAlert";
import ErrorAlert from "../components/error-alert/ErrorAlert";
import useLanguages from "../hooks/useLanguages";
import { API, SERVER_DOMAIN } from "../assets/staticData";
import { AddCircleOutlineRounded, Delete } from "@mui/icons-material";
import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import { IconButton, TextField } from "@mui/material";
import TutorialVideos from "../tab-sections/help-center/TutorialVideos";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import { toast } from "react-toastify";
import ClearIcon from "@mui/icons-material/Clear";
import EditIcon from "@mui/icons-material/Edit";
import EditHelpCenterItem from "../components/editors/EditHelpCenterItem";
import TextEditor from "../components/rich-text/TextEditor/TextEditor";
import ClearCacheButton from "../components/ClearCacheButton/ClearCacheButton";
import { CACHE_KEY } from "../constant/cache-key";

export default function HelpCenter({ user }) {
  const langs = useLanguages();

  const [value, setValue] = useState("0");
  const [value2, setValue2] = useState("one");

  const [data, setData] = useState([]);
  const [images, setImages] = useState([]);
  const [success, setSuccess] = useState(false);
  const [fail, setFail] = useState(false);
  const [loading, setLoading] = useState(true);
  const [openAdd, setOpenAdd] = useState([]);
  const [inputV, setInputV] = useState([]);
  const [editItem, setEditItem] = useState({});
  const [refresh, setRefresh] = useState(false);
  const fileInputRef = useRef(null);
  const hiddenFileInput = useRef();

  const formData = new FormData();

  let userToken = localStorage.getItem("userToken");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChange2 = (event, newValue) => {
    setValue2(newValue);
  };

  let tabStyle = { textTransform: "capitalize", fontWeight: "500" };

  const handleIconInput = (e, index) => {
    const file = e.target.files[0];

    if (file) {
      setInputV([
        ...inputV.map((item, idx) => {
          if (idx === index) {
            return {
              ...item,
              icon: file,
            };
          } else {
            return item;
          }
        }),
      ]);
    }
  };

  // Get Data from backend
  useEffect(() => {
    let docs = langs.map((item) => ({
      menu: [],
      language: item.attributes.language,
    }));
    setData(docs);

    let openDocs = [];
    langs.map(() => {
      openDocs.push({ open: false });
    });
    setOpenAdd(openDocs);

    let inputVDocs = [];
    langs.map(() => {
      inputVDocs.push({
        title: "",
        icon: "",
        faqs: [{ q: "", a: "" }],
        vids: [""],
      });
    });
    setInputV(inputVDocs);

    let imgDocs = langs.map((item) => ({
      headerImg: "",
      headerImgM: "",
      language: item.attributes.language,
    }));
    setImages(imgDocs);

    async function getData() {
      await fetch(`${API}/help-center`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
      }).then(async (res) => {
        const response = await res.json();
        const apiData = response.data?.attributes?.importantTopics || [];

        setData((prevData) => {
          return prevData.map((localItem) => {
            const apiItem = apiData.find((apiItem) => apiItem.language === localItem.language);

            if (apiItem) {
              return {
                ...localItem,
                menu: apiItem.menu || localItem.menu,
              };
            } else {
              return localItem;
            }
          });
        });

        const apiImages = response.data?.attributes?.images || [];

        setImages((prevData) => {
          return prevData.map((localItem) => {
            const apiItem = apiImages.find((apiItem) => apiItem.language === localItem.language);

            if (apiItem) {
              return {
                ...localItem,
                headerImg: apiItem.headerImg || localItem.headerImg,
                headerImgM: apiItem.headerImgM || localItem.headerImgM,
              };
            } else {
              return localItem;
            }
          });
        });

        setLoading(false);
      });
    }

    getData();
  }, [langs]);

  const submitData = (item, index) => {
    fetch(`${API}/help-center`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      },
      body: JSON.stringify({
        data: { importantTopics: data },
      }),
    }).then(async (res) => {
      if (res.ok) {
        setSuccess(true);
      } else {
        setFail(true);
      }
    });
  };

  const handleImageChange = (e, index, type) => {
    const formData = new FormData();
    const file = e.target.files[0];

    if (file) {
      formData.append("files", file);

      fetch(`${API}/upload`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
        body: formData,
      }).then(async (res) => {
        const response = await res.json();
        const iconURL = response[0]?.url;

        let updatedImages = [...images];

        updatedImages[index] = { ...updatedImages[index], [type]: iconURL };

        fetch(`${API}/help-center`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userToken}`,
          },
          body: JSON.stringify({
            data: { images: updatedImages },
          }),
        }).then((res) => {
          if (res.ok) {
            setImages(updatedImages);
            toast("Updated Successfully", {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
              type: "success",
            });
          }
        });
      });
    }
  };

  const onDragEnd = (result, index) => {
    const { source, destination } = result;

    // dropped outside the list
    if (!destination) return;

    const items = Array.from(data[index].menu);
    const [reorderedItem] = items.splice(source.index, 1);
    items.splice(destination.index, 0, reorderedItem);

    setData((prevData) =>
      prevData.map((item, idx) => (idx === index ? { ...item, menu: items } : item))
    );
  };

  const addNewMenuItem = (index) => {
    formData.append("files", inputV[index].icon, inputV[index].icon?.name);

    fetch(`${API}/upload`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
      body: formData,
    }).then(async (res) => {
      const response = await res.json();
      const iconURL = response[0]?.url;
      let tempData = data;

      tempData[index]?.menu.push({
        title: inputV[index]?.title.charAt(0).toUpperCase() + inputV[index]?.title.slice(1),
        icon: iconURL,
        vids: inputV[index]?.vids,
        faqs: inputV[index]?.faqs,
      });

      fetch(`${API}/help-center`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
        body: JSON.stringify({
          data: { importantTopics: tempData },
        }),
      }).then(async (res) => {
        if (res.ok) {
          setData(tempData);
          setSuccess(true);
          setInputV([
            ...inputV.map((item, idx) => {
              if (idx === index) {
                return {
                  ...item,
                  title: "",
                  icon: "",
                  faqs: [{ q: "", a: "" }],
                  vids: [""],
                };
              } else {
                return item;
              }
            }),
          ]);
          setOpenAdd([
            ...openAdd.map((item, idx) => {
              if (idx === index) {
                return { ...item, open: false };
              } else {
                return item;
              }
            }),
          ]);
        } else {
          setFail(true);
        }
      });
    });
  };

  const deleteMenuItem = (index, idx) => {
    let tempData = data;
    let filteredData = tempData[index]?.menu.filter((item, i) => i !== idx);

    tempData[index] = {
      ...tempData[index],
      menu: filteredData,
    };

    setData(tempData);

    fetch(`${API}/help-center`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      },
      body: JSON.stringify({
        data: { importantTopics: tempData },
      }),
    }).then(async (res) => {
      if (res.ok) {
        setSuccess(true);
      } else {
        setFail(true);
      }
    });
  };

  const handleEditorChange = (val, index, indx) => {
    setInputV((prevInputV) => {
      const updatedInputV = [...prevInputV];
      updatedInputV[index] = {
        ...updatedInputV[index],
        faqs: updatedInputV[index].faqs.map((item, idx) =>
          idx === indx ? { ...item, a: val } : item
        ),
      };
      return updatedInputV;
    });
  };

  const handleAddFAQ = (index) => {
    setInputV((prevInputV) => {
      const updatedInputV = [...prevInputV];
      updatedInputV[index] = {
        ...updatedInputV[index],
        faqs: [...updatedInputV[index].faqs, { q: "", a: "" }],
      };
      return updatedInputV;
    });
  };

  const removeQuestion = (index, indx) => {
    let inputDocs = [...inputV];
    let faqsDocs = [...inputV[index].faqs];

    let filtered = faqsDocs.filter((_, i) => i !== indx);

    inputDocs[index].faqs = filtered;

    setInputV(inputDocs);
  };

  const handleAddVid = (index) => {
    setInputV((prevInputV) => {
      const updatedInputV = [...prevInputV];
      updatedInputV[index] = {
        ...updatedInputV[index],
        vids: [...updatedInputV[index].vids, ""],
      };
      return updatedInputV;
    });
  };

  const removeVid = (index, indx) => {
    let inputDocs = [...inputV];
    let vidsDocs = [...inputV[index].vids];

    let filtered = vidsDocs.filter((_, i) => i !== indx);

    inputDocs[index].vids = filtered;

    setInputV(inputDocs);
  };

  return (
    <TabContext value={value}>

      <Box mt={2}>
        <ClearCacheButton
          keys={[
            CACHE_KEY.helpCenter
          ]} />
      </Box>

      <Box sx={{ width: "100%" }}>
        <h3 style={{ textTransform: "capitalize" }}>Help Center Settings</h3>
        <Tabs
          value={value}
          onChange={handleChange}
          textColor="secondary"
          indicatorColor="secondary"
          aria-label="secondary tabs">
          {langs?.map((item, index) => {
            return (
              <Tab
                key={index}
                sx={tabStyle}
                value={index.toString()}
                label={item.attributes.language}
                icon={
                  <img
                    src={SERVER_DOMAIN + item.attributes.icon.data.attributes.url}
                    style={{ width: 25, aspectRatio: 1, borderRadius: 20 }}
                  />
                }
                iconPosition="start"
              />
            );
          })}
        </Tabs>

        {loading ? (
          <></>
        ) : (
          <>
            {langs?.map((item, index) => {
              return (
                <TabPanel value={index.toString()} key={index}>
                  <TabContext value={value2}>
                    <Tabs
                      value={value2}
                      onChange={handleChange2}
                      textColor="secondary"
                      indicatorColor="secondary"
                      aria-label="secondary tabs">
                      <Tab sx={tabStyle} value="one" label="Important Topics" />
                      <Tab sx={tabStyle} value="two" label="Tutorial Videos" />
                    </Tabs>

                    <TabPanel value="one">
                      <div className="help-c">
                        <SuccessAlert show={success} setShow={(v) => setSuccess(v)} />
                        <ErrorAlert show={fail} setShow={(v) => setFail(v)} />

                        <DragDropContext onDragEnd={(result) => onDragEnd(result, index)}>
                          <Droppable droppableId={`menu-${index}`} key={`droppable-${index}`}>
                            {(provided) => (
                              <ul
                                style={{
                                  padding: 0,
                                  marginTop: 0,
                                  width: "100%",
                                }}
                                {...provided.droppableProps}
                                ref={provided.innerRef}>
                                {data[index]?.menu.map((item, idx) => (
                                  <Draggable
                                    key={`item-key-${idx + 40 * 70}`}
                                    draggableId={`item-key-${idx + 40 * 8}`}
                                    index={idx}>
                                    {(provided) => (
                                      <li
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        className="menu-b-i">
                                        <DragIndicatorIcon style={{ color: "#777" }} />
                                        <img
                                          style={{
                                            width: 25,
                                            aspectRatio: 1,
                                            borderRadius: 50,
                                            objectFit: "cover",
                                          }}
                                          src={SERVER_DOMAIN + data[index]?.menu[idx]?.icon}
                                        />
                                        <div>
                                          <p
                                            style={{
                                              margin: 0,
                                              fontSize: 14,
                                              marginBottom: -3,
                                            }}>
                                            {item.title}
                                          </p>
                                          <p
                                            style={{
                                              margin: 0,
                                              fontSize: 12,
                                              color: "grey",
                                            }}>
                                            {item.description}
                                          </p>
                                        </div>
                                        {user.perms[10].edit && (
                                          <div className="delete-menu-item" style={{ right: 10 }}>
                                            <IconButton
                                              onClick={() => {
                                                setEditItem({ index, idx });
                                              }}
                                              sx={{
                                                color: "grey",
                                                "&:hover": {
                                                  color: "#0265d2",
                                                },
                                                transition: "0.3s",
                                              }}>
                                              <EditIcon fontSize="small" />
                                            </IconButton>
                                            <IconButton
                                              onClick={() => deleteMenuItem(index, idx)}
                                              sx={{
                                                color: "grey",
                                                "&:hover": {
                                                  color: "red",
                                                },
                                                transition: "0.3s",
                                              }}>
                                              <Delete fontSize="small" />
                                            </IconButton>
                                          </div>
                                        )}
                                      </li>
                                    )}
                                  </Draggable>
                                ))}
                                {provided.placeholder}
                              </ul>
                            )}
                          </Droppable>
                        </DragDropContext>
                        <div
                          style={{
                            width: "100%",
                            opacity: openAdd[index]?.open ? 1 : 0,
                            minHeight: openAdd[index]?.open ? 270 : 0,
                            maxHeight: openAdd[index]?.open ? 23000 : 0,
                            marginBottom: openAdd[index]?.open ? 10 : 0,
                            visibility: openAdd[index]?.open ? "visible" : "hidden",
                            transition: "0.3s",
                            display: "flex",
                            gap: 25,
                            marginTop: 10,
                          }}>
                          <div className="help-side-b">
                            <p>Label</p>
                            <TextField
                              label="Label"
                              variant="outlined"
                              size="small"
                              value={inputV[index]?.title || ""}
                              onChange={(e) => {
                                setInputV([
                                  ...inputV.map((item, idx) => {
                                    if (idx === index) {
                                      return { ...item, title: e.target.value };
                                    } else {
                                      return item;
                                    }
                                  }),
                                ]);
                              }}
                            />
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 7,
                                marginTop: 3,
                                width: "90%",
                                marginBottom: 20,
                              }}>
                              <p
                                style={{
                                  margin: 0,
                                }}>
                                Icon
                              </p>
                              <img
                                style={{
                                  width: 25,
                                  aspectRatio: 1,
                                  borderRadius: 50,
                                  objectFit: "cover",
                                }}
                                src={
                                  inputV[index]?.icon
                                    ? URL.createObjectURL(inputV[index]?.icon)
                                    : require("../assets/placeholder-image.png")
                                }
                              />
                              <input
                                ref={fileInputRef}
                                type="file"
                                accept="image/*"
                                onChange={(e) => handleIconInput(e, index)}
                              />
                            </div>
                            <p>YouTube Video Links</p>
                            {inputV[index]?.vids.map((itm, indx) => (
                              <div>
                                <TextField
                                  key={indx}
                                  label={"Video Link " + (indx + 1)}
                                  variant="outlined"
                                  size="small"
                                  value={inputV[index]?.vids[indx] || ""}
                                  onChange={(e) => {
                                    setInputV([
                                      ...inputV.map((item, idx) => {
                                        if (idx === index) {
                                          const updatedVids = item.vids.map((vid, vidIdx) =>
                                            vidIdx === indx ? e.target.value : vid
                                          );
                                          return { ...item, vids: updatedVids };
                                        } else {
                                          return item;
                                        }
                                      }),
                                    ]);
                                  }}
                                />

                                <IconButton
                                  style={{ marginLeft: 5 }}
                                  onClick={() => removeVid(index, indx)}>
                                  <ClearIcon sx={{ color: "red" }} />
                                </IconButton>
                              </div>
                            ))}

                            <div
                              className="flex"
                              style={{
                                backgroundColor: "var(--green)",
                                borderRadius: 5,
                                color: "#fff",
                                width: "50%",
                                margin: "5px 0",
                                height: 35,
                                cursor: "pointer",
                              }}
                              key={index}
                              onClick={() => handleAddVid(index)}>
                              Add New Video
                            </div>
                          </div>
                          <div className="help-side-a">
                            <p>FAQs</p>
                            {inputV[index]?.faqs.map((itm, indx) => (
                              <div key={indx} style={{ marginTop: 10 }}>
                                <TextField
                                  sx={{ width: "90%" }}
                                  label={`Question ${indx + 1}`}
                                  variant="outlined"
                                  size="small"
                                  value={inputV[index]?.faqs[indx]?.q || ""}
                                  onChange={(e) => {
                                    setInputV((prevInputV) => {
                                      const updatedInputV = [...prevInputV];
                                      updatedInputV[index] = {
                                        ...updatedInputV[index],
                                        faqs: updatedInputV[index].faqs.map((item, idx) =>
                                          idx === indx ? { ...item, q: e.target.value } : item
                                        ),
                                      };
                                      return updatedInputV;
                                    });
                                  }}
                                />

                                <IconButton
                                  style={{ marginLeft: 5 }}
                                  onClick={() => removeQuestion(index, indx)}>
                                  <ClearIcon sx={{ color: "red" }} />
                                </IconButton>

                                <div style={{ marginTop: 10 }}>
                                  <TextEditor
                                    placeholder={"Answer"}
                                    value={inputV[index]?.faqs[indx]?.a || ""}
                                    onChange={(val) => handleEditorChange(val, index, indx)}
                                  />
                                </div>
                              </div>
                            ))}
                            <div
                              className="flex"
                              style={{
                                backgroundColor: "var(--green)",
                                borderRadius: 5,
                                color: "#fff",
                                width: "25%",
                                margin: "5px 0",
                                height: 35,
                                cursor: "pointer",
                              }}
                              key={index}
                              onClick={() => handleAddFAQ(index)}>
                              Add New FAQ
                            </div>
                          </div>
                        </div>

                        {user.perms[10].edit && (
                          <>
                            <div
                              className="submitBTN"
                              style={{
                                width: "65%",
                                fontSize: 15,
                                height: 40,
                                gap: 7,
                                borderRadius: 7,
                                marginTop: 10,
                                backgroundColor: openAdd[index]?.open
                                  ? inputV[index]?.faqs[0]?.q == "" ||
                                    inputV[index]?.faqs[0]?.a == "" ||
                                    inputV[index]?.title == "" ||
                                    inputV[index]?.icon == ""
                                    ? "red"
                                    : "var(--link)"
                                  : "var(--link)",
                              }}
                              onClick={() => {
                                if (openAdd[index]?.open == false) {
                                  setOpenAdd([
                                    ...openAdd.map((item, idx) => {
                                      if (idx === index) {
                                        return { ...item, open: true };
                                      } else {
                                        return item;
                                      }
                                    }),
                                  ]);
                                } else {
                                  if (
                                    inputV[index]?.faqs[0]?.q !== "" &&
                                    inputV[index]?.faqs[0]?.a !== "" &&
                                    inputV[index]?.icon !== "" &&
                                    inputV[index]?.title !== ""
                                  ) {
                                    addNewMenuItem(index);
                                  } else {
                                    setOpenAdd([
                                      ...openAdd.map((item, idx) => {
                                        if (idx === index) {
                                          return { ...item, open: false };
                                        } else {
                                          return item;
                                        }
                                      }),
                                    ]);
                                  }
                                }
                              }}>
                              {openAdd[index]?.open
                                ? inputV[index]?.faqs[0]?.q == "" ||
                                  inputV[index]?.faqs[0]?.a == "" ||
                                  inputV[index]?.title == "" ||
                                  inputV[index]?.icon == ""
                                  ? "Cancel"
                                  : "Submit"
                                : "Add New"}
                              {openAdd[index]?.open ? (
                                ""
                              ) : (
                                <AddCircleOutlineRounded style={{ fontSize: 22 }} />
                              )}
                            </div>
                            <div className="submitBTN" onClick={() => submitData(item, index)}>
                              Save Changes
                            </div>
                          </>
                        )}
                      </div>
                    </TabPanel>
                    <TabPanel value="two" sx={{ padding: 2 }}>
                      <TutorialVideos index={index} />
                    </TabPanel>
                  </TabContext>

                  <div className="divider"></div>

                  {user.perms[10].edit && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        gap: 25,
                        flexWrap: "wrap",
                      }}>
                      <div className="w-4/12">
                        <h3 className="ml-3">Header Image</h3>

                        <div
                          className="group relative w-full mt-4 rounded-[15px] overflow-hidden cursor-pointer "
                          onClick={() => hiddenFileInput.current.click()}>
                          <img
                            style={{
                              width: "100%",
                              aspectRatio: 1,
                              objectFit: "cover",
                              transition: "0.2s",
                            }}
                            src={
                              images[index]?.headerImg
                                ? SERVER_DOMAIN + images[index]?.headerImg
                                : require("../assets/placeholder-image.png")
                            }
                          />

                          <div className="group absolute top-0 left-0 w-full rounded-[15px] h-full bg-black bg-opacity-0 hover:bg-opacity-30 transition-opacity flex items-center justify-center">
                            <CameraAltIcon
                              style={{ fontSize: 45 }}
                              className="text-white opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                            />
                          </div>

                          <input
                            type="file"
                            accept="image/png, image/jpeg"
                            onChange={(e) => handleImageChange(e, index, "headerImg")}
                            ref={hiddenFileInput}
                            style={{ display: "none" }}
                          />
                        </div>
                      </div>
                      <div className="w-4/12">
                        <h3 className="ml-3">Mobile Header Image</h3>

                        <div
                          className="group relative w-full mt-4 rounded-[15px] overflow-hidden cursor-pointer "
                          onClick={() => hiddenFileInput.current.click()}>
                          <img
                            style={{
                              width: "100%",
                              aspectRatio: 1,
                              objectFit: "cover",
                              transition: "0.2s",
                            }}
                            src={
                              images[index]?.headerImgM
                                ? SERVER_DOMAIN + images[index]?.headerImgM
                                : require("../assets/placeholder-image.png")
                            }
                          />

                          <div className="group absolute top-0 left-0 w-full rounded-[15px] h-full bg-black bg-opacity-0 hover:bg-opacity-30 transition-opacity flex items-center justify-center">
                            <CameraAltIcon
                              style={{ fontSize: 45 }}
                              className="text-white opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                            />
                          </div>

                          <input
                            type="file"
                            accept="image/png, image/jpeg"
                            onChange={(e) => handleImageChange(e, index, "headerImgM")}
                            ref={hiddenFileInput}
                            style={{ display: "none" }}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </TabPanel>
              );
            })}
          </>
        )}

        <EditHelpCenterItem
          data={data}
          setData={setData}
          itemToEdit={editItem}
          setItemToEdit={setEditItem}
        />
      </Box>
    </TabContext>
  );
}
